import CreateApprovalClaimModal from './CreateApprovalClaimModal'

export default CreateApprovalClaimModal
